// Extrai o objeto "produto" de cada item da lista vinda da API.
// O endpoint /produtos/pesquisar devolve { produto: {...} }, mas para defesa
// também aceitamos um produto plano caso o shape mude.
const getProduto = (item) => (item && item.produto ? item.produto : item);

const incrementCount = (map, value) => {
    if (value === null || value === undefined || value === '') return;
    const key = String(value);
    const entry = map.get(key);
    if (entry) {
        entry.count += 1;
    } else {
        map.set(key, { value: key, label: key, count: 1 });
    }
};

const sortByLabel = (a, b) => a.label.localeCompare(b.label, 'pt-BR', { sensitivity: 'base' });

const finalize = (map) => Array.from(map.values()).sort(sortByLabel);

export const deriveFilterOptions = (products) => {
    const griffe = new Map();
    const grupo = new Map();
    const subgrupo = new Map();
    const grade = new Map();

    if (!Array.isArray(products)) {
        return { griffe: [], grupo: [], subgrupo: [], grade: [] };
    }

    products.forEach((item) => {
        const p = getProduto(item);
        if (!p) return;

        incrementCount(griffe, p.griffe);
        incrementCount(grupo, p.grupo_produto);
        incrementCount(subgrupo, p.subgrupo_produto);

        // grade pode vir como array (product.grades) ou string (product.grade)
        if (Array.isArray(p.grades)) {
            p.grades.forEach((g) => incrementCount(grade, g));
        } else {
            incrementCount(grade, p.grade);
        }
    });

    return {
        griffe: finalize(griffe),
        grupo: finalize(grupo),
        subgrupo: finalize(subgrupo),
        grade: finalize(grade)
    };
};

const appendList = (parts, key, list) => {
    if (Array.isArray(list) && list.length > 0) {
        parts.push(`${key}=${list.map(encodeURIComponent).join(',')}`);
    }
};

const appendNumber = (parts, key, value) => {
    if (value !== null && value !== undefined && value !== '' && !Number.isNaN(Number(value))) {
        parts.push(`${key}=${encodeURIComponent(value)}`);
    }
};

export const buildFilterQuery = (filters) => {
    if (!filters) return '';
    const parts = [];
    appendList(parts, 'griffe', filters.griffe);
    appendList(parts, 'grupo', filters.grupo);
    appendList(parts, 'subgrupo', filters.subgrupo);
    appendList(parts, 'grade', filters.grade);
    appendList(parts, 'filial', filters.filial);
    appendNumber(parts, 'preco_min', filters.precoMin);
    appendNumber(parts, 'preco_max', filters.precoMax);
    return parts.length > 0 ? `&${parts.join('&')}` : '';
};

export const countActiveFilters = (filters) => {
    if (!filters) return 0;
    return (
        (filters.griffe?.length || 0) +
        (filters.grupo?.length || 0) +
        (filters.subgrupo?.length || 0) +
        (filters.grade?.length || 0) +
        (filters.filial?.length || 0) +
        (filters.precoMin !== null && filters.precoMin !== undefined ? 1 : 0) +
        (filters.precoMax !== null && filters.precoMax !== undefined ? 1 : 0)
    );
};
